<template>
  <DraggableFields
    left-heading="Unused Fields"
    right-heading="Displayed Fields"
    :source-fields.sync="fieldMap"
    :selected-columns.sync="projectResultFields"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import DraggableFields from '@/components/common/DraggableFields/DraggableFields.vue'
import { FieldTypes } from '@/types'
import { SEARCH_CONFIG_KEY } from '@/constants'

const components = {
  DraggableFields,
}

@Component({ components })
export default class SearchResultFields extends Vue {
  get fieldMap () {
    const leafLevel = Math.max(...this.$typedStore.primary.app.config.fieldMap.map(f => f.level || 0))
    return this.$typedStore.primary.app.config.fieldMap.filter(item => {
      return item.type === FieldTypes.STRING || item.level === leafLevel
    })
  }

  get projectResultFields () {
    return this.$typedStore.primary.app.config[SEARCH_CONFIG_KEY].projectResultFields || []
  }

  set projectResultFields (newArray) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SEARCH_CONFIG_KEY, 'projectResultFields'],
      value: newArray,
    })
  }
}

</script>
